import * as ActionTypes from "../ActionTypes";
import API from "../../network/dashboardAPI";
import _ from 'lodash';
import UploadService from "../../services/FileUploadService";
export const getBrands = (data, dispatch) =>{
    API.getBrands(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_BRANDS,
                payload : response.data,
                success: response.success,
            })
        }
    })
}

export const getBrandById = async (id, dispatch) => {
    try {
        const response = await API.getBrandById(id);
        const data = await response.json(); // Ensure response is properly parsed

        if (data.success) {
            return data;
        }
        return null;
    } catch (error) {
        console.error("Error fetching brand:", error);
        return null;
    }
};


export const addBrand = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.addBrands(data)
    .then((response) => response.json())
    .then((response)=>{
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.ADD_BRANDS,
                payload : response.data,
                success: response.success,
            })
            window.location.href = "/admin/brands";
        }else{
          //  console.log(response.error.errors[0].message);
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.error.errors[0].message,
                success: response.success,
            })

        }
    })
}

export const updateBrand = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.updateBrands(data)
    .then((response) => response.json())
    .then((response)=>{
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.UPDATE_BRANDS,
                payload : response.data,
                success: response.success,
            })
            window.location.href = "/admin/brands";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.error.errors[0].message,
                success: response.success,
            })

        }
    })
}

export const getCountries= (data, dispatch) =>{
  API.getCountries(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.GET_COUNTRIES,
          payload: response.data,
          success: response.success,
        });
      }
    });
}

export const setSuccess = (data,dispatch) => {
    dispatch({
        type : ActionTypes.SET_SUCCESS,
        success : data,
    })
}

export const setError = (data,dispatch) =>{
    dispatch({
        type : ActionTypes.SET_ERROR,
        payload : data,
        success : false
    })
}

export const setLoading = (data,dispatch) => {
    dispatch({
        type : ActionTypes.SET_LOADING,
        payload : data,
    })
}


export const getCategory = (data,dispatch) => {
    API.getCategory(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_CATEGORY,
                payload : response.data,
                success: response.success,
            })
        }
    })
}

export const getCategoryByID = async (body, dispatch) => {
  try {
    const response = await API.getCategoryByID(body);
    const data = await response.json(); // Ensure response is properly parsed

    if (data.success) {
        return data;
    }
    return null;
  } catch (error) {
    console.error("Error fetching brand:", error);
    return null;
  }
}



export const addCategory = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.addCategory(data)
    .then((response) => response.json())
    .then((response)=>{
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.ADD_CATEGORY,
                payload : response.data,
                success: response.success,
            })
            window.location.href = "/admin/categories";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.error.errors[0].message,
                success: response.success,
            })

        }
    })
}



export const updateCategory = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.updateCategory(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.UPDATE_CATEGORY,
                payload : response.data,
                success: response.success,
            })
            setLoading(false,dispatch);
            window.location.href = "/admin/categories";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.error.errors[0].message,
                success: response.success,
            })

        }
    })
}




export const getSubCategory = (data,dispatch) => {
    API.getSubCategory(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_SUB_CATEGORY,
                payload : response.data,
                success: response.success,
            })
        }
    })
}



export const addSubCategory = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.addSubCategory(data)
    .then((response) => response.json())
    .then((response)=>{
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.ADD_SUB_CATEGORY,
                payload : response.data,
                success: response.success,
            })
            window.location.href = "/admin/subCategories";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.error.errors[0].message,
                success: response.success,
            })

        }
    })
}



export const updateSubCategory = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.updateSubCategory(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.UPDATE_SUB_CATEGORY,
                payload : response.data,
                success: response.success,
            })
            setLoading(false,dispatch);
            window.location.href = "/admin/subCategories";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.error.errors[0].message,
                success: response.success,
            })

        }
    })
}


export const getProduct = (data,dispatch) => {
    API.getProduct(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_PRODUCTS,
                payload : response.data,
                success: response.success,
            })
        }
    })
}

export const getPromotionProducts = (data, dispatch) => {
  dispatch({
    type: ActionTypes.Loading_Enable 
 });
  API.getPromotionProducts(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Disable
        });
        dispatch({
          type: ActionTypes.GET_PROMO_PRODUCTS,
          payload: response.data,
          success: response.success,
        })
      }
    })
}

export const getProductToRelate = (data, dispatch) => {
  dispatch({
     type: ActionTypes.Loading_Enable 
  });
  API.getProduct(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Disable
        });
        dispatch({
          type: ActionTypes.GET_PRODUCTS,
          payload: response.data,
          success: response.success,
        });
      } else {
        dispatch({
          type: ActionTypes.Loading_Disable
        });
      }
    });
};

export const getRelatedProducts = (data, relatedPage, setRelatedPage, handleShowToast, dispatch) => {
  dispatch({
     type: ActionTypes.Loading_Enable 
  });
  API.getRelatedProduct(data)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.GET_RELATED_PRODUCTS,
          payload: response.data,
          success: response.success,
        });
        if (response.data.totalPages && relatedPage > response.data.totalPages) {
          setRelatedPage((current) => current - 1);
        }
      } else {
        handleShowToast("error", response.message);
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      handleShowToast("error", err.message);
    });
};

export const getAllAdminSaleCampaigns = (data, dispatch) => {
  dispatch({
     type: ActionTypes.Loading_Enable 
  });
  API.getAllAdminSaleCampaigns(data)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.GET_CAMPAIGNS,
          payload: response.data,
        });
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      console.log(err.message);
    });
};

export const createdAminSaleCampaign = (body, dispatch) => {
  dispatch({
     type: ActionTypes.Loading_Enable 
  });
  API.createdAminSaleCampaign(body)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Disable
        });
        getAllAdminSaleCampaigns({}, dispatch);
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      console.log(err.message);
    });
};

export const updateAdminSaleCampaign = (body, dispatch) => {
  dispatch({
     type: ActionTypes.Loading_Enable 
  });
  API.updateAdminSaleCampaign(body)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Disable
        });
        getAllAdminSaleCampaigns({}, dispatch);
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      console.log(err.message);
    });
};

export const deleteAdminSaleCampaign = (body, dispatch) => {
  dispatch({
     type: ActionTypes.Loading_Enable 
  });
  API.deleteAdminSaleCampaign(body)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Disable
        });
        getAllAdminSaleCampaigns({}, dispatch);
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      console.log(err.message);
    });
};

export const getAdminProductsSaleCampaign = (data, page, setPage, dispatch) => {
  dispatch({
    type: ActionTypes.Loading_Enable 
  });
  API.getAdminProductsSaleCampaign(data)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.GET_CAMPAIGN_PRODUCTS,
          payload: response.data,
          success: response.success,
        });
        if (response.data.totalPages && page > response.data.totalPages) {
          setPage((current) => current - 1);
        }
      }
    }).catch((err) => {
      console.log(err);
      dispatch({
        type: ActionTypes.Loading_Disable
      });
    });
};

export const createAdminProductsSaleCampaign = (data, dispatch) => {
  API.createAdminProductsSaleCampaign(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Enable
        });
        getAllAdminSaleCampaigns({}, dispatch);
        API.getAdminProductsSaleCampaign(data)
        .then((response) => response.json())
        .then((response) => {
          dispatch({
            type: ActionTypes.Loading_Disable
          });
          if (response.success) {
            dispatch({
              type: ActionTypes.GET_CAMPAIGN_PRODUCTS,
              payload: response.data,
              success: response.success,
            });
          }
        }).catch((err) => {
          console.log(err);
          dispatch({
            type: ActionTypes.Loading_Disable
          });
        });
      }
    }).catch((err) => {
      console.log(err)
    });
};

export const addAdminProductsSaleCampaign = (data, dispatch) => {
  API.addAdminProductsSaleCampaign(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Enable
        });
        API.getAdminProductsSaleCampaign(data)
        .then((response) => response.json())
        .then((response) => {
          dispatch({
            type: ActionTypes.Loading_Disable
          });
          if (response.success) {
            dispatch({
              type: ActionTypes.GET_CAMPAIGN_PRODUCTS,
              payload: response.data,
              success: response.success,
            });
          }
        }).catch((err) => {
          console.log(err);
          dispatch({
            type: ActionTypes.Loading_Disable
          });
        });
        if(data?.fetchPromo){
          getPromotionProducts(data, dispatch);
        }
      }
    }).catch((err) => {
      console.log(err)
    });
};

export const updateAdminProductsSaleCampaign = (data, dispatch) => {
  API.updateAdminProductsSaleCampaign(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Enable
        });
        API.getAdminProductsSaleCampaign(data)
        .then((response) => response.json())
        .then((response) => {
          dispatch({
            type: ActionTypes.Loading_Disable
          });
          if (response.success) {
            dispatch({
              type: ActionTypes.GET_CAMPAIGN_PRODUCTS,
              payload: response.data,
              success: response.success,
            });
          }
        }).catch((err) => {
          console.log(err);
          dispatch({
            type: ActionTypes.Loading_Disable
          });
        });
        getAllAdminSaleCampaigns({}, dispatch);
      }
    }).catch((err) => {
      console.log(err)
    });
};

export const deleteAdminProductsSaleCampaign = (data, dispatch) => {
  API.deleteAdminProductsSaleCampaign(data)
    .then((response) => response.json())
    .then((response) => {
      if (response.success) {
        dispatch({
          type: ActionTypes.Loading_Enable
        });
        API.getAdminProductsSaleCampaign(data)
        .then((response) => response.json())
        .then((response) => {
          dispatch({
            type: ActionTypes.Loading_Disable
          });
          if (response.success) {
            dispatch({
              type: ActionTypes.GET_CAMPAIGN_PRODUCTS,
              payload: response.data,
              success: response.success,
            });
          }
        }).catch((err) => {
          console.log(err);
          dispatch({
            type: ActionTypes.Loading_Disable
          });
        });
      }
    }).catch((err) => {
      console.log(err)
    });
};

export const addRelatedProduct = (data, handleShowToast, dispatch) => {
  dispatch({
    type: ActionTypes.Loading_Enable
  });
  API.addRelatedProduct(data)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        handleShowToast("success","Successfully added!");
        dispatch({
          type: ActionTypes.ADD_RELATED_PRODUCTS,
          payload: response.success,
        });
      } else {
        handleShowToast("error", response.message);
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      handleShowToast("error", err.message);
    });
};

export const removeRelatedProduct = (data, handleShowToast, dispatch) => {
  dispatch({
    type: ActionTypes.Loading_Enable
  });
  API.removeRelatedProduct(data)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        handleShowToast("success","Successfully remmoved!");
        dispatch({
          type: ActionTypes.REMOVE_RELATED_PRODUCTS,
          payload: response.success,
        });
      } else {
        handleShowToast("error", response.message);
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      handleShowToast("error", err.message);
    });
};

export const searchProduct = (data,dispatch) => {
    API.searchProduct(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.SEARCH_PRODUCTS,
                payload : response.data,
                success: response.success,
            })
        }
    })
};

export const getWarehouses = (data,dispatch) => {
    API.getWarehouse(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_WAREHOUSES,
                payload : response.list,
                success: response.success,
            })
        }
    })
};

export const getSuppliers = (data,dispatch) => {
    API.getSuppliers(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_SUPPLIERS,
                payload : response.data,
                success: response.success,
            })
        }
    })
};

export const addSupplier = (data, setShowToast, setToastMessage, setToastBgColor, dispatch) => {
  setLoading(true, dispatch);
  UploadService.addSupplier(data)
    .then((response) => {
      setLoading(false, dispatch);
			if (response.data.success) {
				dispatch({
					type: ActionTypes.ADD_SUPPLIER,
					payload: response.data.data,
					success: response.data.success,
        });
        setShowToast(true);
        setToastBgColor('bg-success');
        setToastMessage(response.data.message);
        let timeout = setTimeout(() => {
          window.location.href = '/admin/suppliers';
        }, 1000);
        return () => clearTimeout(timeout);
      } else {
        dispatch({
          type: ActionTypes.SET_ERROR,
          payload: response.data,
					success: response.data.success,
				});
        setShowToast(true);
        setToastBgColor('bg-danger');
        setToastMessage(response.data.message);
			}
		});
};

export const initSupplierOrders = (data, dispatch) => {
  dispatch({
    type : ActionTypes.INIT_SUPPLIER_ORDERS,
    payload : data,
    success: true,
  })
};

export const updateSupplierOrders = (data, dispatch) => {
  dispatch({
    type : ActionTypes.UPDATE_SUPPLIER_ORDERS,
    payload : data,
    success: true,
  })
};

export const initSuppliersLists = (data, dispatch) => {
  let newData = _.orderBy(data, [function(o) { return o.totalPending; }], ["desc"]);

  dispatch({
    type : ActionTypes.INIT_SUPPLIERS_LISTS,
    payload : newData,
    success: true,
  })
};

export const updateSuppliersLists = (data, dispatch) => {
  dispatch({
    type : ActionTypes.UPDATE_SUPPLIERS_LISTS,
    payload : data,
    success: true,
  })
};

export const addUsers = (data, setShowToast, setToastMessage, setToastBgColor, dispatch) => {
  setLoading(true, dispatch);
  UploadService.addUsers(data)
    .then((response) => {
      setLoading(false, dispatch);
			if (response.data.success) {
				dispatch({
					type: ActionTypes.ADD_USERS,
					payload: response.data.data,
					success: response.data.success,
        });
        setShowToast(true);
        setToastBgColor('bg-success');
        setToastMessage(response.data.message);
        let timeout = setTimeout(() => {
          window.location.href = '/admin/users';
        }, 1000);
        return () => clearTimeout(timeout);
      } else {
        dispatch({
          type: ActionTypes.SET_ERROR,
          payload: response.data,
					success: response.data.success,
				});
        setShowToast(true);
        setToastBgColor('bg-danger');
        setToastMessage(response.data.message);
			}
		});
};

export const getSubCategoryMap = (data,dispatch) => {
    API.getSubCategoryMap(data)
    .then((response) => response.json())
    .then((response)=>{
        if(response.success){
            dispatch({
                type : ActionTypes.GET_SUB_CATEGORY_BY_CATEGORY,
                payload : response.data,
                success: response.success,
            })
        }
    })
}

export const addProduct = (data,slider, dispatch) =>{
    setLoading(true,dispatch);
    API.addProduct(data)
    .then((response) => response.json())
    .then((response)=>{
        if (slider != null) {
            // setIsUploded(true)
            let formData = new FormData();

            for (let i = 0; i < slider.length; i++) {
                formData.append("image", slider[i]);
            }
            formData.append('store_id', "1")
            formData.append("item_id", response.item_id);

            UploadService.uploadSliderFromDashboard(formData)
                .then(response => {
                    if (response.data.success) {
                        console.log(response.data)
                        console.log(response.data.data[0].url)

                    }
                });

        }
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.ADD_PRODUCTS,
                payload : response.data,
                success: response.success,
            })
	        window.location.href = "/admin/products";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.data,
                success: response.success,
            })

        }
    })
}



export const updateProduct = (data,slider,removeSlider, dispatch) =>{
    setLoading(true,dispatch);
    let promise = []
    API.updateProduct(data)
    .then((response) => response.json())
    .then(async (response)=>{
        if(removeSlider != []){
            for(let i = 0 ; i< removeSlider.length ; i++){
                promise.push(UploadService.removeSliderFromDashboard({
                    id: removeSlider[i]
                }))
            }
        }


	    if (slider != null) {
            // setIsUploded(true)
            let formData = new FormData();

            for (let i = 0; i < slider.length; i++) {
                formData.append("image", slider[i]);
            }
            formData.append('store_id', "1")
            formData.append("item_id", data.item_id);

		    promise.push(UploadService.uploadSliderFromDashboard(formData))
        }
        await Promise.all(promise).then(response =>{
            console.log("Upload done")
        })
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.ADD_PRODUCTS,
                payload : response.data,
                success: response.success,
            })
	        window.location.href = "/admin/products";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.data,
                success: response.success,
            })

        }
    })
}



export const getOrders = (data, dispatch) =>{
    setLoading(true,dispatch);
    API.getOrders(data)
    .then((response) => response.json())
    .then((response)=>{
        setLoading(false,dispatch);
        if(response.success){
            dispatch({
                type : ActionTypes.GET_ORDERS,
                payload : response.data,
                success: response.success,
            })
            // window.location.href = "/admin/orders";
        }else{
            dispatch({
                type : ActionTypes.SET_ERROR,
                payload : response.data,
                success: response.success,
            })

        }
    })
}

export const updateOrders = (data, dispatch) => {
  dispatch({
    type : ActionTypes.UPDATE_ORDERS,
    payload : data,
    success: true,
  })
};

export const uploadPromotion = (data, handleToast, dispatch) => {
	setLoading(true, dispatch);
	API.uploadPromotion(data)
		.then((response) => response.json())
		.then((response) => {
			setLoading(false, dispatch);
			if (response.success) {
				dispatch({
					type: ActionTypes.UPLOAD_PROMOTION,
					payload: response.data,
					success: response.success,
				});
        handleToast();
			} else {
				dispatch({
					type: ActionTypes.SET_ERROR,
					success: response.success,
        });
        setTimeout(() => {
          alert('Something went wrong!');
        }, 500);
			}
		});
};

export const getAllAdminAppVersions = (data, dispatch) => {
  dispatch({
    type: ActionTypes.Loading_Enable 
  });
  API.getAllAdminAppVersion(data)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      if (response.success) {
        dispatch({
          type: ActionTypes.GET_APP_VERSIONS,
          payload: response.data,
        });
      }
    }).catch((err) => {
      dispatch({
        type: ActionTypes.Loading_Disable
      });
      console.log(err.message);
    });
}

export const fetchFeatureMaintenance = async ({URL_FILE_MAINTENANCE, setMaintenanceMode, setMounted}) => {
  try{
    const response = await fetch(
      URL_FILE_MAINTENANCE,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          'Cache-Control': 'max-age=0, no-cache, no-store, must-revalidate',
        }
      }
    );
    
    if (!response.ok) {
      setMaintenanceMode(false)
      window.checkMaintenanceCondition(false);
      localStorage.setItem("maintenanceMode", false);
      setMounted(true);
      throw new Error(`Failed to fetch file: ${response.status} - ${response.statusText}`);
    }

    const content = await response.text();
    const numbersArray = content.match(/\d+/g) || [];
    if(numbersArray.length > 0){
        if(parseInt(numbersArray[0]) === 1){
          setMaintenanceMode(true)
          localStorage.setItem("maintenanceMode", true);
          window.checkMaintenanceCondition(true);
          setMounted(true);
        }else{
          setMaintenanceMode(false)
          window.checkMaintenanceCondition(false);
          localStorage.setItem("maintenanceMode", false);
          setMounted(true);
        }
    }
  } catch (error) {
    setMaintenanceMode(false)
    window.checkMaintenanceCondition(false);
    localStorage.setItem("maintenanceMode", false);
    setMounted(true);
    console.error('Error reading file from S3:', error);
  }
};